import { z } from 'zod'
import ApiService from '../api.service'

export type EspelhoPeriodo = {
    id: string
    filename: string | null
    dataInicial: string
    dataFinal: string
    status: 'processando' | 'pronto' | 'erro'
    avisos: string[]
    createdAt: Date
}

export const CreateEspelhoPeriodoSchema = z
    .object({
        empresaId: z.number().nullish(),
        dataInicial: z.string().nonempty('Obrigatório'),
        dataFinal: z.string().nonempty('Obrigatório'),
        funcionarioIds: z
            .array(z.number())
            .nonempty('Selecione ao menos um funcionário'),
        formato: z.enum(['zip', 'pdf']).default('zip'),
    })
    .refine(data => data.dataInicial <= data.dataFinal, {
        message: 'A data inicial deve ser anterior à data final',
        path: ['dataFinal'],
    })

export type CreateEspelhoPeriodo = z.infer<typeof CreateEspelhoPeriodoSchema>

export const espelhoPeriodo = new ApiService<
    CreateEspelhoPeriodo,
    EspelhoPeriodo
>('espelho-periodo')
